import { createSelector } from "reselect"
import { get, first, last, chain, size, some, filter } from "lodash"
import { getStartDate, getEndDate } from "selectors/dates"
import { getSelectedViewsFactors, getSelectedViews } from "selectors/factors"
import { aggregateExposuresFactors } from "helpers/factorClassification/index"
import { getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"

const EMPTY_OBJECT = {}

export const getRawFactorSensitivityData = state => get(state, "global.data.factorSensitivity.data.model.simulation.factorSensitivity", EMPTY_OBJECT)

function formatFactorSensitivity(factorSensitivity, selectedViewFactors, selectedViews, mustAggregateFactors, factorsClassification, styleAggregation) {
  const count = size(factorSensitivity)
  return chain(factorSensitivity)
    .map(({ date, factors }, index) => {
      // Always return last date
      if (factors.length || index === count - 1) {
        let sensFactors = factors
        if (mustAggregateFactors) {
          sensFactors = aggregateExposuresFactors(factorsClassification, factors, styleAggregation, "sensitivity")
        }

        if (size(selectedViews)) {
          sensFactors = chain(factors)
            .filter(factor => some(selectedViewFactors, item => item.id === factor.id))
            .map(factor => ({ ...factor, customView: true }))
            .concat(sensFactors)
            .value()
        }

        return ({
          date,
          factors: chain(sensFactors)
            .keyBy("id")
            .mapValues("sensitivity")
            .value(),
        })
      }
      return null
    })
    .compact()
    .value()
}

export const getFactorSensitivity = createSelector(
  [getRawFactorSensitivityData, getSelectedViewsFactors, getSelectedViews, getMustAggregateFactors, getModelFactorsClassification, getStyleExposureAggregation],
  formatFactorSensitivity,
)

export const getFilteredFactorSensitivity = createSelector(
  [getFactorSensitivity, getStartDate, getEndDate],
  (factorSensitivity, startDate, endDate) =>
    filter(factorSensitivity, data => data.date >= startDate && data.date <= endDate),
)

export const getFirst = createSelector(
  [getFactorSensitivity],
  first,
)

export const getCurrent = createSelector(
  [getFactorSensitivity],
  last,
)

export const getFirstFactorSensitivityDate = createSelector(
  [getFilteredFactorSensitivity],
  (factorSensitivity) => get(first(factorSensitivity), "date", null),
)
